import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LoaderService } from '@services/loader.service';

@Injectable()
export class ApiRouteInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) { }
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url != '/notification/admin' && request.url != '/notification/read/all/admin') {
      this.loaderService.startLoading();
    }

    return next
      .handle(
        request.clone({
          url: `${environment.baseURL}${request.url}`,
        })
      )
      .pipe(finalize(() => {
        if (request.url != '/notification/admin'&& request.url != '/notification/read/all/admin') {
          this.loaderService.stopLoading()
        }
      }));
  }
}

export const apiRouteProviderInterceptor = { provide: HTTP_INTERCEPTORS, useClass: ApiRouteInterceptor, multi: true };
